const TRACK_IDS = {
  SEARCH_DISTRICT_LIBRARY: 'search_district_library',
  RECOMMENDATIONS_LCB: 'recommendations_lcb',
  RECOMMENDATIONS_CLASS_PROFILE: 'recommendations_class_profile',
  RECOMMENDATIONS_STUDENT_PROFILE: 'recommendations_student_profile',
  GENAI_DASHBOARD_ILP: 'genai_dashboard_ilp',
  CURRICULUM_PA: 'curriculum_pa',
  UNIFIED_ACTION_HUB: 'unified_action_hub',
  OPEN_PEARY: 'open_peary',
}

const PHASES = {
  NONE: 'none',
  AGGRESSIVE_DISMISSED: 'aggressive_dismissed',
  COMPLETED: 'completed',
  MODERATE_SKIPPED: 'moderate_skipped',
}

const MODERATE_DELAY_MS = 4 * 24 * 60 * 60 * 1000
const MODERATE_EXPIRY_MS = 30 * 24 * 60 * 60 * 1000

const EDUCATION_JOYRIDE_TARGETS = {
  DISTRICT_LIBRARY_FILTER: '[data-joyride-id="districtLibraryFilter"]',
  DASHBOARD_ILP: '[data-joyride-id="dashboardILP"]',
  IDENTIFY_LEARNING_GAPS: '[data-joyride-id="identifyLearningGaps"]',
  PLAN_INTERVENTION: '[data-joyride-id="planIntervention"]',
  CURRICULUM_PAGE: '[data-joyride-id="curriculumSidebar"]',
}

const EDUCATION_JOYRIDE_SEGMENT_CTA = {
  [TRACK_IDS.SEARCH_DISTRICT_LIBRARY]: 'DistrictLibrarySearch',
  [TRACK_IDS.RECOMMENDATIONS_LCB]: 'RecommendationsLCB',
  [TRACK_IDS.RECOMMENDATIONS_CLASS_PROFILE]: 'RecommendationsClassProfile',
  [TRACK_IDS.RECOMMENDATIONS_STUDENT_PROFILE]: 'RecommendationsStudentProfile',
  [TRACK_IDS.GENAI_DASHBOARD_ILP]: 'GenAI_ILP',
  [TRACK_IDS.CURRICULUM_PA]: 'CurriculumPA',
  [TRACK_IDS.UNIFIED_ACTION_HUB]: 'UnifiedActionHub',
  [TRACK_IDS.OPEN_PEARY]: 'OpenPeary',
}

module.exports = {
  TRACK_IDS,
  PHASES,
  MODERATE_DELAY_MS,
  MODERATE_EXPIRY_MS,
  EDUCATION_JOYRIDE_TARGETS,
  EDUCATION_JOYRIDE_SEGMENT_CTA,
  ALL_TRACK_IDS: Object.values(TRACK_IDS),
  ALL_PHASES: Object.values(PHASES),
}
